import { RouteType } from "types/RouteType";
import { RootStore } from "@intrasync/stores";
import MMDailyReportStore from "stores/millermize/MMDailyReportStore";

// Daily production report (plan item 15): what was poured on a given day —
// per-job marks/pieces/cubic feet plus a trailing-week strip — so Creede no
// longer compiles Steven's snapshot report by hand. Data comes from
// MMDailyReportStore (GET /mm-production-items/daily-production), loaded
// lazily on first visit (see beforeEnter) so a not-yet-deployed backend
// endpoint can't toast errors at login.
//
// NOTE: this route is Creede's surface for now; moving the same card onto
// Steven's dashboard is pending the client confirming which login/dashboard
// Steven actually uses (plan item 15 decision).
const dailyReportRoute: RouteType = {
  name: "MM Daily Report",
  path: "/mm/daily-report",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Daily Report",
      component: () => import("./DailyReport.Header"),
      enableRefreshButton: false,
      enableBackButton: false,
    },
    body: {
      component: () => import("./DailyReport.Body"),
      grayBackground: true,
    },
  },
  group: "Miller-Mize",
  menuOrder: 7,
  requiresAuth: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // Fire-and-forget: the body renders its own loading state. Cast follows
    // the established route-hook pattern (see Payments.Route.ts) — MM stores
    // are registered dynamically, so RootStore types them loosely.
    const store = rootStore.mmDailyReportStore as MMDailyReportStore | undefined;
    store?.ensureLoaded();
    return true;
  },
};

export default dailyReportRoute;
